import type { FetchedVisitType, VisitTypeList } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  VISIT_TYPES_QUERY_KEY,
  VISIT_TYPES_UPDATE_QUERY_KEY,
  VISIT_TYPES_URL
} from './queryConstants'
import type { VisitFormType } from './useVisitTypesList'

type UseVisitTypesUpdateProps = {
  onSuccess?: () => void
}

type UseVisitTypesUpdateReturn = {
  updateVisitTypes: (values: VisitFormType) => void
  isUpdateVisitTypesLoading: boolean
}

export const useVisitTypesUpdate = ({
  onSuccess
}: UseVisitTypesUpdateProps): UseVisitTypesUpdateReturn => {
  const queryClient = useQueryClient()

  const updateFunction = (values: {
    types: VisitTypeList
    flexiVisits: boolean
  }) =>
    postJSON({
      url: VISIT_TYPES_URL,
      method: 'PUT',
      isRota: true,
      json: values
    })

  const {
    mutateAsync: updateVisitTypes,
    isLoading: isUpdateVisitTypesLoading
  } = useMutation<FetchedVisitType, unknown, any>(
    [VISIT_TYPES_UPDATE_QUERY_KEY],
    updateFunction,
    {
      onSuccess: () => {
        onSuccess?.()
        queryClient.invalidateQueries([VISIT_TYPES_QUERY_KEY])
      }
    }
  )

  return {
    updateVisitTypes,
    isUpdateVisitTypesLoading
  }
}
